import { array, mixed, object, ref, string } from 'yup';

export const emailSchema = string()
  .email('Please enter a valid email address.')
  .required('This field cannot be empty.');

export const requiredSchema = string().required('Required');

export const notEmptySchema = string().required('This field cannot be empty.');

export const arrayOfObjectsRequiredSchema = array().of(object({}));

export const newPasswordSchema = {
  password: string()
    .min(8)
    .max(15)
    .matches(
      /^((?=.*\d)(?=.*[a-zA-Z]).{8,15})$/,
      `Password should be min 8, max 15 characters, should have atleast 1 letter, 1 number.`
    )
    .required('This field cannot be empty.'),
  confirmPassword: mixed()
    .oneOf([ref('password')], 'Passwords must match')
    .required('This field cannot be empty.'),
};
